define('CustomProductCollection.PLP.Styles.View', [
    'SCView',
    'custom_product_collection_plp_styles_view.tpl'
], function CustomProductCollectionPLPStylesViewModule(
    SCViewComponent,
    template
) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    /**
     * PLP styles view for custom product collection.
     * Adds parent context flag to the template, sets item internalid.
     * @constructor
     * @param {Object} options - View options (unused, but included for SCView compatibility)
     */
    function CustomProductCollectionPLPStylesView(options) {
        SCView.call(this);

        this.options = options || {};
        this.template = template;

        this.attributes = {
            id: 'CustomProductCollectionPLPStylesView',
            'class': 'CustomProductCollection-PLP-Styles-View'
        };

        // Require context data for item info
        this.contextDataRequest = ['item'];
    }

    // Inherit parent instance methods.
    CustomProductCollectionPLPStylesView.prototype = Object.create(SCView.prototype);
    CustomProductCollectionPLPStylesView.prototype.constructor =
        CustomProductCollectionPLPStylesView;

    /**
     * Returns context variables for the PLP styles template.
     * @returns {Object} { internalid: string|number, parent: boolean, url: string }
     */
    CustomProductCollectionPLPStylesView.prototype.getContext = function getContext() {
        var item = this.contextData.item();

        return {
            internalid: item.internalid,
            parent: item.custitem_cpc_is_parent_item,
            url: item._url || item.urlcomponent
        };
    };

    // Return the AMD constructor.
    return CustomProductCollectionPLPStylesView;
});
